import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { PaginateQuery, PaginatorModel, UUID } from 'symbols';
import { Order, Sort, TYPE_SEARCH } from '../../symbols';
import { ClientFilterModel, ClientModel, StoryModel } from '../symbols';

@Injectable()
export class ClientService {

  public sortDefault$ = new BehaviorSubject({ sort: Sort.CREATED, order: Order.DESC });
  private readonly apiUrl = '/api/client';

  constructor(private http: HttpClient) {
  }


  getClientListPaginate(filter: PaginateQuery<ClientFilterModel>): Observable<PaginatorModel<ClientModel>> {
    const params: { [key: string]: any } = {
      page: filter?.page || 1,
      limit: filter?.limit || 150,
      sortBy: `${filter?.sortBy[0][0]}:${filter?.sortBy[0][1]}`,
      typeSearch: TYPE_SEARCH.BY_METADATA
    };

    params['search'] = filter?.filter?.searchText || '';

    if (filter?.filter?.isDebt) {
      params['filter.isDebt'] = filter?.filter?.isDebt;
    }

    return this.http.get<PaginatorModel<ClientModel>>(`${this.apiUrl}/list/`, { params });
  }

  getClientListLazy(url: string): Observable<PaginatorModel<ClientModel>> {
    return this.http.get<PaginatorModel<ClientModel>>(url);
  }

  getClientListForSelectors(phone: string): Observable<ClientModel[]> {
    return this.http.get<PaginatorModel<ClientModel>>(`${this.apiUrl}/list/`, { params: { search: phone } })
      .pipe(map(c => c.data));
  }

  getStory(id: UUID): Observable<StoryModel> {
    return this.http.get<StoryModel>(`${this.apiUrl}/story/${id}`);
  }

  getClientInfo(id: UUID): Observable<ClientModel> {
    return this.http.get<ClientModel>(`${this.apiUrl}/info/${id}`);
  }

  // Exact lookup by unique phone — used to deterministically resolve an existing
  // client's id right before saving, so a lost id never produces a duplicate.
  getClientByPhone(phone: string): Observable<ClientModel | null> {
    return this.http.get<ClientModel | null>(`${this.apiUrl}/client-by-phone/${phone}`);
  }

  getClientInfoByToken(): Observable<StoryModel> {
    return this.http.get<StoryModel>(`${this.apiUrl}/relation-docs`);
  }
}
